import React from 'react'
import 'App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRouter from './routers/PrivateRouter';
import OrderList from 'pages/OrderList';
import ProductList from 'pages/product/ProductList';
import AddProduct from 'pages/product/AddProduct';
import UpdateProduct from 'pages/product/UpdateProduct';
// banner
import BannerList from 'pages/banner/List';
import AddBanner from 'pages/banner/Add';
import UpdateBanner from 'pages/banner/Update';
//users
import UsersList from 'pages/users/UsersList';
import AddUser from 'pages/users/AddUser';
import UpdateUser from 'pages/users/UpdateUser';
import ListCustomer from 'pages/customer/ListCustomer';
import AddCustomer from 'pages/customer/AddCustomer';
import UpdateCustomer from 'pages/customer/UpdateCustomer';
import BillList from 'components/billing/BillList';
import BillDetails from 'components/billing/BillDetails';
import CorderList from 'pages/orderList/CorderList';
import CreateCustomOrder from 'pages/orderList/CreateCustomOrder';
import CreateBill from 'components/billing/CreateBill';
import ListNumber from 'pages/gussingnumbers/ListNumber';
import GameBids from 'pages/gamebids/GameBids'
import Withdrawel from 'pages/orderList/Withdrawel';
import ListPlay from 'pages/customer_play/ListPlay';
import QrCodeList from 'pages/qrcodes/QrCodeList';
import WalletCustomerList from 'pages/customer/WalletCustomerList';
import UserLogin from 'pages/UserLogin';
import QuestionList from 'pages/questions/QuestionList';
import AddQuestions from 'pages/questions/AddQuestions';
import QuestionUpdate from 'pages/questions/QuestionUpdate';
import Servicemen from 'pages/servicemen/Servicemen';
import AddServiceMen from 'pages/servicemen/AddServiceMen'

import CategoryList from 'pages/category/CategoryList';
import AddCategory from 'pages/category/AddCategory';
import UpdateCategory from 'pages/category/UpdateCategory';
import ChemicalList from 'pages/chemical/ChemicalList';
import AddChemical from 'pages/chemical/AddChemical';
import MachineList from 'pages/machine/MachineList';
import AddMachine from 'pages/machine/AddMachine';
import SupplyOrderList from 'pages/supplyOrders/SupplyOrderList';
import ServiceManWorkDetails from 'pages/servicemen/ServiceManWorkDetails';
import Leaves from 'pages/leaves/Leaves';
import LiveTracking from 'pages/tracking/LiveTracking';
import MinOrderList from 'pages/minOrder/MinOrderList';
import StaticPages from 'pages/staticPages/StaticPages';
import Announcements from 'pages/announcements/Announcements';
import CityList from 'pages/city/CityList';


function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/signin" element={<Login />} />
          <Route path="/userlogin" element={<UserLogin />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </>
      <Routes>
        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/orderlist" element={<OrderList />} />
          <Route path="/cities" element={<CityList />} />

          {/* this is new router for the serviceman app */}
          <Route path="/products" element={<ProductList />} />
          <Route path="/products/add" element={<AddProduct />} />
          <Route path="/products/update/:id" element={<UpdateProduct />} />
          <Route path="/minorder" element={<MinOrderList />} />


          {/* user  */}
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/update/:id" element={<UpdateUser />} />


          {/* Customer */}
          <Route path="/customer" element={<ListCustomer />} />
          <Route path="/customer/add" element={<AddCustomer />} />
          <Route path="/customer/update/:id" element={<UpdateCustomer />} />
          <Route path="/customer/wallethistory/:id" element={<WalletCustomerList />} />

          {/* service man  */}
          <Route path="/addservicemen" element={<AddServiceMen />} />
          <Route path="/servicemen" element={<Servicemen />} />
          <Route path='/servicemanwork/:id' element={<ServiceManWorkDetails/>}/>
          <Route path="/leaves" element={<Leaves />} />


          {/* category */}
          <Route path="/category" element={<CategoryList />} />
          <Route path="/category/add" element={<AddCategory />} />
          <Route path="/category/update/:id" element={<UpdateCategory />} />

          {/* end here */}

          {/* chemical */}
          <Route path="/chemical" element={<ChemicalList />} />
          <Route path="/chemical/add" element={<AddChemical />} />

          {/* machine */}
          <Route path="/machine" element={<MachineList />} />
          <Route path="/machine/add" element={<AddMachine />} />

          {/* supply orders (chemical & machine purchases) */}
          <Route path="/supply-orders" element={<SupplyOrderList />} />


          {/* banner */}
          <Route path="/banner" element={<BannerList />} />
          <Route path="/banner/add" element={<AddBanner />} />
          <Route path="/banner/update/:id" element={<UpdateBanner />} />




          {/* billing */}
          <Route path="/billing" element={<CreateBill />} />
          <Route path="/billing-list" element={<BillList />} />
          <Route path="/billing/details/:id" element={<BillDetails />} />






          {/* customer order list */}
          <Route path="/customerorder" element={<CorderList />} />
          <Route path="/customerorder/create" element={<CreateCustomOrder />} />
          <Route path="/withdrawel" element={<Withdrawel />} />

          {/* gussingnumber  list */}
          <Route path="/gussingnumber" element={<ListNumber />} />

          {/* gussingnumber  list */}
          <Route path="/qrcode" element={<QrCodeList />} />

          {/* gamebid  list */}
          <Route path="/gamebids" element={<GameBids />} />
          <Route path="/gamebidsbycustomer/:id" element={<ListPlay />} />

          {/* Question */}
          <Route path="/questions" element={<QuestionList />} />
          <Route path="/questions/add" element={<AddQuestions />} />
          <Route path="/questions/update/:id" element={<QuestionUpdate />} />

           <Route path="/tracking/update/:id" element={<LiveTracking />} />

          {/* static pages & announcements */}
          <Route path="/staticpages" element={<StaticPages />} />
          <Route path="/announcements" element={<Announcements />} />

          <Route path="/*" element={<h1>No page avaliable</h1>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
